// extracted by mini-css-extract-plugin
export default {"cls1":"Header-cls1___5582dfdf3703c623c52","cls2":"Header-cls2___b12a0a01ecc0e4b2b91 Header-cls1___5582dfdf3703c623c52"};